import { defineStore } from 'pinia'

export type State = {
  isBooted: boolean
}

export const useCommandBarStore = defineStore('commandBar', {
  state: (): State => ({
    isBooted: false,
  }),
  getters: {},
  actions: {
    setBootStatus(isBooted: boolean): void {
      this.isBooted = isBooted
    },
  },
})

export default useCommandBarStore
